module.exports = __webpack_public_path__ + "img/ic_all_task_order.f9eb8051.svg";